import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL


export const saveQuotation = (data: any) => {
    return axios.post(`${apiUrl}/quotations`, data)
}